import palette from '@/styles/_colors.module.scss';

const colors = {};

Object.keys(palette).forEach((el) => {
  const name = el.split('--');
  if (!colors[name[0]]) colors[name[0]] = {};
  colors[name[0]][name[1]] = palette[el];
});

export default function (color: string, variant: string = 'base') {
  return colors[color][variant] || '#FF1B1B';
}
